import { render, staticRenderFns } from "./precent.vue?vue&type=template&id=34ced13c&scoped=true"
import script from "./precent.vue?vue&type=script&lang=js"
export * from "./precent.vue?vue&type=script&lang=js"
import style0 from "./precent.vue?vue&type=style&index=0&id=34ced13c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ced13c",
  null
  
)

export default component.exports